(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["see-in-action"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    const lockScroll = () => {
      const y = window.scrollY || 0;
      document.documentElement.classList.add('see-in-action-open');
      document.body.dataset.siaScrollY = String(y);
      Object.assign(document.body.style, { position: 'fixed', top: `-${y}px`, left: '0', right: '0', width: '100%' });
    };

    const unlockScroll = () => {
      if (document.querySelector('.see-in-action-popup.is-open')) return;
      const y = parseInt(document.body.dataset.siaScrollY || '0', 10);
      document.documentElement.classList.remove('see-in-action-open');
      Object.assign(document.body.style, { position: '', top: '', left: '', right: '', width: '' });
      delete document.body.dataset.siaScrollY;
      window.scrollTo(0, y);
    };

    const popupEmbedSrc = (src) => {
      if (!src) return '';
      try {
        const url = new URL(src, window.location.origin);
        if (url.hostname.includes('youtube.com')) {
          url.searchParams.set('autoplay', '1');
          url.searchParams.set('mute', '0');
        } else if (url.hostname.includes('tiktok.com')) {
          url.searchParams.set('autoplay', '1');
        }
        return url.toString();
      } catch (error) {
        return src;
      }
    };

    const addToCart = async (variantId) => {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
      );

      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sections.join(','),
          sections_url: `${root()}variants/${variantId}`
        })
      });
      const json = await response.json();
      if (!response.ok) throw new Error(json.description || json.message || 'Add to cart failed');

      const settings = window.themeVariables && window.themeVariables.settings;
      if (settings && (settings.cartType === 'page' || settings.pageType === 'cart')) {
        window.location.href = `${root()}cart`;
        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:drawer-render', { bubbles: true, detail: { baseEvent: 'variant:add', sections: json.sections } })
      );
      document.dispatchEvent(new CustomEvent('initialize-cart:drawer'));

      const cart = await (await fetch(`${root()}cart.js`)).json();
      cart.sections = json.sections;
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } })
      );
    };

    const initCarousel = (section) => {
      const track = section.querySelector('[data-sia-track]');
      const prev = section.querySelector('[data-sia-prev]');
      const next = section.querySelector('[data-sia-next]');
      if (!track || !prev || !next) return;

      const step = () => {
        const slide = track.querySelector('.see-in-action__slide');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      };

      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      };

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };

    const initHoverPlay = (section) => {
      section.querySelectorAll('[data-sia-hover-play]').forEach((media) => {
        const video = media.querySelector('video');
        if (!video) return;
        media.addEventListener('mouseenter', () => {
          video.muted = true;
          video.play().catch(() => {});
        });
        media.addEventListener('mouseleave', () => {
          video.pause();
          video.currentTime = 0;
        });
      });

      section.querySelectorAll('.see-in-action__media video').forEach((video) => {
        const media = video.closest('.see-in-action__media');
        video.addEventListener('play', () => media.classList.add('is-playing'));
        video.addEventListener('pause', () => media.classList.remove('is-playing'));
      });
    };

    const initPopup = (section) => {
      const popup = section.querySelector('[data-sia-popup]');
      const slides = [...section.querySelectorAll('[data-sia-slide]')];
      if (!popup || !slides.length) return;

      document.querySelectorAll(`body > #${CSS.escape(popup.id)}`).forEach((stale) => stale.remove());
      document.body.appendChild(popup);

      const videoEl = popup.querySelector('.see-in-action-popup__video');
      const iframeEl = popup.querySelector('.see-in-action-popup__iframe');
      const productEl = popup.querySelector('[data-sia-popup-product]');
      const playBtn = popup.querySelector('[data-sia-play]');
      const muteBtn = popup.querySelector('[data-sia-mute]');
      const prevBtn = popup.querySelector('[data-sia-popup-prev]');
      const nextBtn = popup.querySelector('[data-sia-popup-next]');
      const bottomBar = popup.querySelector('[data-sia-bottom-bar]');
      const stage = popup.querySelector('[data-sia-swipe]');

      let index = 0;
      let mode = 'native';

      const readData = (slide) => {
        try {
          return JSON.parse(slide.querySelector('[data-sia-data]').textContent);
        } catch (error) {
          return null;
        }
      };

      const syncUi = () => {
        const native = mode === 'native';
        playBtn.classList.toggle('is-playing', native && !videoEl.paused && !videoEl.ended);
        playBtn.setAttribute('aria-label', playBtn.classList.contains('is-playing') ? 'Pause video' : 'Play video');
        muteBtn.classList.toggle('is-unmuted', native && !videoEl.muted);
        muteBtn.setAttribute('aria-label', muteBtn.classList.contains('is-unmuted') ? 'Mute video' : 'Unmute video');
        prevBtn.disabled = index <= 0;
        nextBtn.disabled = index >= slides.length - 1;
      };

      const stopMedia = () => {
        videoEl.pause();
        videoEl.removeAttribute('src');
        videoEl.removeAttribute('poster');
        videoEl.innerHTML = '';
        videoEl.hidden = true;
        iframeEl.src = 'about:blank';
        iframeEl.hidden = true;
      };

      const load = (i) => {
        const slide = slides[i];
        if (!slide) return;
        index = i;
        stopMedia();

        const product = slide.querySelector('[data-sia-product]');
        productEl.innerHTML = product ? product.innerHTML : '';

        const data = readData(slide);
        if (data && data.type === 'native' && data.sources && data.sources.length) {
          mode = 'native';
          muteBtn.hidden = false;
          bottomBar.hidden = false;
          videoEl.hidden = false;
          if (data.poster) videoEl.poster = data.poster;
          data.sources.forEach((source) => {
            const el = document.createElement('source');
            el.src = source.src;
            if (source.type) el.type = source.type;
            videoEl.appendChild(el);
          });
          videoEl.loop = !!data.loop;
          videoEl.muted = false;
          videoEl.load();
          videoEl.play().catch(() => {
            videoEl.muted = true;
            videoEl.play().catch(() => {});
          });
        } else if (data && data.embedSrc) {
          mode = 'embed';
          muteBtn.hidden = true;
          bottomBar.hidden = true;
          iframeEl.hidden = false;
          iframeEl.src = popupEmbedSrc(data.embedSrc);
        }

        syncUi();
      };

      const open = (i) => {
        section.querySelectorAll('.see-in-action__media video').forEach((video) => video.pause());
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => popup.classList.add('is-open'));
        lockScroll();
        load(i);
      };

      const close = () => {
        if (popup.hidden) return;
        stopMedia();
        popup.classList.remove('is-open');
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        unlockScroll();
        section.querySelectorAll('.see-in-action__media video[autoplay]').forEach((video) => {
          video.muted = true;
          video.play().catch(() => {});
        });
      };

      slides.forEach((slide, i) => {
        const media = slide.querySelector('[data-sia-open]');
        if (!media) return;
        media.addEventListener('click', () => open(i));
        media.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          open(i);
        });
      });

      popup.querySelectorAll('[data-sia-close]').forEach((el) => el.addEventListener('click', close));
      prevBtn.addEventListener('click', () => index > 0 && load(index - 1));
      nextBtn.addEventListener('click', () => index < slides.length - 1 && load(index + 1));

      playBtn.addEventListener('click', () => {
        if (mode !== 'native') return;
        if (videoEl.paused) videoEl.play().catch(() => {});
        else videoEl.pause();
      });

      muteBtn.addEventListener('click', () => {
        if (mode !== 'native') return;
        videoEl.muted = !videoEl.muted;
        syncUi();
      });

      videoEl.addEventListener('play', syncUi);
      videoEl.addEventListener('pause', syncUi);

      let startX = 0;
      let startY = 0;
      stage.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (event.target.closest('button')) return;
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        const delta = Math.abs(dy) >= Math.abs(dx) ? dy : dx;
        if (Math.abs(delta) < 45) return;
        if (delta < 0 && index < slides.length - 1) load(index + 1);
        if (delta > 0 && index > 0) load(index - 1);
      }, { passive: true });

      popup.addEventListener('click', async (event) => {
        const atc = event.target.closest('[data-sia-atc]');
        if (!atc || atc.disabled) return;

        const label = atc.textContent;
        atc.disabled = true;
        atc.textContent = 'Adding...';

        try {
          await addToCart(atc.dataset.variantId);
          close();
        } catch (error) {
          console.error('[see-in-action] add to cart failed', error);
          atc.textContent = label;
          atc.disabled = false;
          return;
        }

        atc.textContent = label;
        atc.disabled = false;
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });

      section._siaClose = close;
    };

    const init = (section) => {
      if (!section || section.dataset.siaReady === 'true') return;
      section.dataset.siaReady = 'true';
      initCarousel(section);
      initHoverPlay(section);
      initPopup(section);
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-sia-root]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-sia-root]').forEach((section) => {
        if (section._siaClose) section._siaClose();
        const id = section.id + '-popup';
        document.querySelectorAll(`body > #${CSS.escape(id)}`).forEach((el) => el.remove());
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
